import { Fragment, useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Flex, Form, Input, Spin } from 'antd';
import { ERR_MESSAGE, REGEX_PASSWORD_FORMAT, REGEX_PASSWORD_LENGTH, RESPONSE_ERR } from "@/constant";
import logoCCBJI from "@/assets/img/2800_CCBJI_Logo.bmp";
import logoFVJ from "@/assets/img/2801_FVJ_Logo.bmp";
import { checkUrlForgotPassword } from '@/features/homepage/api/ApiCheckUrlForgotPassword';
import { setNewPassword } from '@/features/homepage/api/ApiSetNewPassword';
import { LoadingSpinner } from '@/components/SpinnerOverlay';
// SCN012

const ForgotPasswordPage = () => {
  const [loading, setLoading] = useState(false);
  const [showSystemError, setSystemError] = useState('');
  const [urlValidateResult, setUrlValidateResult] = useState(false);
  const inputRef = useRef(null);
  const token_param = useParams();
  const [error, setError] = useState('');
  const navigate = useNavigate();

  // Effect: Validate token in URL when page loads
  useEffect(() => {
    const validateToken = async () => {
      setLoading(true);
      try {
        const data_request = {
          url_token: token_param.token,
        };
        const res = await checkUrlForgotPassword(data_request);
        if (res && res.status == "success") {
          setUrlValidateResult(true);
        } else {
          setUrlValidateResult(false);
          navigate('/forgot-password-expired');
        }
      } catch (error) {
        setSystemError(ERR_MESSAGE.WAS001_MESSAGE);
        setUrlValidateResult(false);
      } finally {
        setLoading(false);
      }
    };

    validateToken();
  }, [navigate, token_param]);

  // Effect: Focus input when form is ready and not loading
  useEffect(() => {
    if (urlValidateResult && inputRef.current && !loading) {
      inputRef.current.focus();
    }
  }, [urlValidateResult, loading]);

  if (loading == true) {
    return <LoadingSpinner />;
  }

  // Handle form submit for new password
  const handleSubmit = async (values: any) => {
    setLoading(true);
    const input_set_password = {
      new_password: values.newPassword || null,
      url_token: token_param.token || null,
    };

    try {
      // Call API to set new password
      const res = await setNewPassword(input_set_password);
      if (res) {
        setLoading(false);
        if (res && res.status == "success") {
          navigate("/forgot-password-inform");
        }
      }
    } catch (error) {
      // Show error messages based on error code
      if (error.response.data.error_code == RESPONSE_ERR.E0501) {
        setError(ERR_MESSAGE.E0501_MESSAGE);
      } else if (error.response.data.error_code == ERR_MESSAGE.WAS002_MESSAGE) {
        setError(ERR_MESSAGE.WAS002_MESSAGE);
      } else {
        setError(ERR_MESSAGE.WAS002_MESSAGE);
      }
    } finally {
      setLoading(false);
    }
  };

  // Handler: go back to login page when logo is clicked
  const backToLogin = () => navigate('/login');

  return (

    <div style={{ display: loading ? 'none' : 'block' }}>
      <Fragment>
        <nav className="navbar navbar-expand-lg navbar-light justify-content-start bg-white p-0" >
          <ul className="navbar-nav ms-auto">
            <li className="nav-item d-flex justify-content-around" onClick={backToLogin} style={{ height: '71px' }}>
              <img className="m-1" src={logoCCBJI} alt="Logo 1" style={{ height: '90%' }} />
              <img className="m-1" src={logoFVJ} alt="Logo 1" style={{ height: '90%' }} />
            </li>
          </ul>
        </nav >
        <div className="container-fluid background-cover-external">
          <ol className="breadcrumb">
            <li className="breadcrumb-item active">パスワード再設定</li>
          </ol>
          <div className="jumbotron">
            <div className="section">
              <div className="card-body regular-font" >
                <Form
                  name="reset-password"
                  layout="vertical"
                  onFinish={handleSubmit}
                  size="large"
                  validateTrigger="onSubmit"
                >
                  <ul className="list-group list-group-flush">
                    <li className="list-group-item">
                      <p style={{ color: 'red' }}>{error}</p>
                      <span>パスワード</span>
                      <Flex vertical gap={12}>
                        <Form.Item
                          name="newPassword"
                          validateFirst={true}
                          rules={[
                            { required: true, message: "パスワード入力必須" },
                            {
                              pattern: REGEX_PASSWORD_LENGTH,
                              message: "パスワードは 大文字、小文字、数字、特殊記号を含め10文字以上、32文字以内である必要があります"
                            },
                            {
                              pattern: REGEX_PASSWORD_FORMAT,
                              message: "パスワードは 大文字、小文字、数字、特殊記号を含め10文字以上、32文字以内である必要があります"
                            },
                          ]}
                        >
                          <Input.Password className='input-primary' ref={inputRef} size="large" />
                        </Form.Item>
                      </Flex>
                    </li>
                    <li className="list-group-item">
                      <span>パスワード（確認用）</span>
                      <Flex vertical gap={12}>
                        <Form.Item
                          name="reNewPassword"
                          validateFirst={true}
                          rules={[
                            { required: true, message: "パスワード（確認）入力必須" },
                            ({ getFieldValue }) => ({
                              validator(_, value) {
                                if (!value || getFieldValue('newPassword') === value) {
                                  return Promise.resolve();
                                }
                                return Promise.reject(new Error('変更後のパスワードと一致していません'));
                              },
                            }),
                          ]}
                        >
                          <Input.Password className='input-primary' size="large" />
                        </Form.Item>
                      </Flex>
                    </li>
                  </ul>
                  <ul className="list-group list-group-flush">
                    <li className="list-group-item">
                      <span>上記の登録でよろしければ「確定」を押してください</span> <br />
                      <br />
                      <div className="d-flex justify-content-center">
                        <Button htmlType='submit' className="btn bg-coca" style={{ width: "200px" }} >
                          <span className="text-white" style={{ fontSize: '14px', fontWeight: '500' }}  >確定 </span>
                        </Button>
                      </div>

                    </li>
                  </ul>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    </div>
  );
};

export default ForgotPasswordPage;
